var _linearGradient, _path, _linearGradient2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7sJyQCZzdsESd~lp6E9tqa",
    x1: 32,
    x2: 32,
    y1: 16.25,
    y2: 48.312,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7sJyQCZzdsESd~lp6E9tqa)",
    d: "M26.064,45.003c12.076,0,18.68-10.005,18.68-18.68c0-0.284-0.006-0.567-0.019-0.849 c1.282-0.927,2.396-2.083,3.275-3.399c-1.176,0.523-2.442,0.875-3.77,1.034c1.355-0.813,2.396-2.099,2.887-3.632 c-1.269,0.752-2.673,1.299-4.169,1.594c-1.198-1.276-2.904-2.074-4.792-2.074c-3.626,0-6.566,2.94-6.566,6.565 c0,0.515,0.058,1.016,0.17,1.497c-5.456-0.274-10.295-2.887-13.532-6.859c-0.564,0.97-0.889,2.097-0.889,3.3 c0,2.278,1.159,4.289,2.922,5.465c-1.077-0.033-2.089-0.329-2.974-0.821c-0.001,0.027-0.001,0.055-0.001,0.084 c0,3.18,2.263,5.834,5.267,6.436c-0.551,0.15-1.132,0.231-1.731,0.231c-0.423,0-0.834-0.042-1.234-0.118 c0.836,2.608,3.259,4.506,6.133,4.56c-2.247,1.761-5.078,2.81-8.154,2.81c-0.53,0-1.052-0.03-1.566-0.091 C18.906,43.916,22.356,45.003,26.064,45.003"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7sJyQCZzdsESd~lp6E9tqb",
    x1: 32,
    x2: 32,
    y1: 5.25,
    y2: 59.38,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7sJyQCZzdsESd~lp6E9tqb)",
    d: "M32,58C17.663,58,6,46.337,6,32S17.663,6,32,6s26,11.663,26,26S46.337,58,32,58z M32,8 C18.767,8,8,18.767,8,32s10.767,24,24,24s24-10.767,24-24S45.233,8,32,8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.6771dad5cf7882268c43215e69812c64.svg";
export { ForwardRef as ReactComponent };